if (typeof global === 'undefined') {
  (window as any).global = globalThis;
}

export {};
